import {useRespondToAliveUpdate} from '../../hooks/use-refetch-on-alive-update'
import {Button} from '@primer/react'
import {useState} from 'react'
import styles from './RefreshButton.module.css'
import {SyncIcon} from '@primer/octicons-react'
import {Link as RouterLink, useLocation} from '@github-ui/react-router'
import {useComparisonInfoActions} from '../../stores/selectors'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'

export function RefreshButton({aliveChannel}: {aliveChannel: string}) {
  const [show, setShow] = useState(false)
  const {markComparisonOutdated} = useComparisonInfoActions()

  const liveUpdateHandler = () => {
    markComparisonOutdated()
    setShow(true)
  }

  // we only need to display the refresh button when the base or head sha has changed (via git_updated)
  useRespondToAliveUpdate(aliveChannel, liveUpdateHandler, {git_updated: true})

  if (!show) {
    return null
  }

  return <DataRouterRefreshButton />
}

function DataRouterRefreshButton() {
  const location = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const robustSmallScreenSupport = useFeatureFlag('prx_robust_small_screen_support')

  const onClick = async () => {
    setIsLoading(true)
  }

  return (
    <Button
      as={RouterLink}
      // link to the current path to trigger a data router navigation
      // eventually need to apply active params but for now this is sufficient
      to={location.pathname}
      variant="invisible"
      className={styles.refresh}
      leadingVisual={SyncIcon}
      size="small"
      onClick={onClick}
      loading={isLoading}
      preventScrollReset
      {...(robustSmallScreenSupport && {'data-refresh-button-visible': true})}
    >
      Refresh
    </Button>
  )
}
